import { useTranslation } from 'react-i18next'

import { FullScreenErrorWall } from './FullScreenErrorWall'

interface RetrySignOutErrorWallProps {
  message: string
  title?: string
  onRetry: () => void | Promise<void>
  secondaryActionLabel?: string
  onSignOut?: () => void | Promise<void>
}

export function RetrySignOutErrorWall({
  message,
  title,
  onRetry,
  secondaryActionLabel,
  onSignOut,
}: RetrySignOutErrorWallProps) {
  const { t } = useTranslation(['common'])

  return (
    <FullScreenErrorWall
      title={title ?? t('common:error')}
      message={message}
      primaryActionLabel={t('common:error_try_again')}
      onPrimaryAction={onRetry}
      secondaryActionLabel={secondaryActionLabel ?? t('common:error_sign_out')}
      onSecondaryAction={onSignOut}
    />
  )
}
